
  import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import pagelist from '@/components/pagelistcomponent';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  @Component
  export default class autoruntrade extends pagelist {
    model: proxy.MerchantLoginWhiteListDto = new proxy.MerchantLoginWhiteListDto();
    get prox() {
            return new proxy.MerchantClientServiceProxy();
        }
        getpage(){
            this.prox.queryModelLoginWhiteList().then(x=>{
                this.model = x;
            })
        }
        async created() {
            this.getpage();
        }
        save() {
    
        this.prox.changeLoginWhiteList(this.model).then(() => {
                this.$Notice.success({title:'保存成功'});
            });
                
         
        }


    
  }
  